// button edit cell
export interface IButtonEditCellProps {
  row: any
  table: any
}
export enum ActionBasicEditCellName {
  Edit = "edit",
  Remove = "remove",
  Add = "add",
  None = "",
}

export enum ActionConfirmEditCellName {
  Cancel = "cancel",
  Done = "done",
  None = "",
}
// table editable
export type TData = {
  id: number,
  [key: string]: any
}
export type HandleSaveType<T> = (obj: T, params?: IOptionalOnSave) => void
export interface IOptionalOnSave {
  object?: any
  index?: number
}
export interface ITableEditableParams {
  id: string
  columns: any
  fetchData: TData[]
  newRow?: TData
  handleSave?: HandleSaveType<TData[]>
  param?: IOptionalOnSave
}

export interface IEditRow {
  actionBasic?: ActionBasicEditCellName
  actionConfirm?: ActionConfirmEditCellName
  id: number
  isEdit: boolean
}